// Generated by scripts/mdi/import-questionnaires.mjs from MDI "CJC-1295 / Ipamorelin 09.17.26" (2f292cd1-559d-4a54-8f80-cbbf17d69703). Re-run instead of editing.
import { FormType } from '../../../form-types';
import { mdiCJC1295IpamorelinAnswerField } from './questions';

export const mdiCJC1295Ipamorelin: FormType<mdiCJC1295IpamorelinAnswerField> = {
  name: 'CJC-1295 / Ipamorelin',
  validityLength: 25,
  questions: [
    {
      key: 'mdiCJC1295Ipamorelin_sex',
      next: {
        condition: { 'mdiCJC1295Ipamorelin_sex.female': true },
        key: 'mdiCJC1295Ipamorelin_pregnancy',
        els: 'mdiCJC1295Ipamorelin_breastfeeding'
      }
    },
    'mdiCJC1295Ipamorelin_pregnancy',
    {
      key: 'mdiCJC1295Ipamorelin_breastfeeding',
      next: {
        switch: [
          {
            condition: { 'mdiCJC1295Ipamorelin_pregnancy.yes': true },
            key: 'mdiCJC1295Ipamorelin_wereSorryTreatmentNotMedically'
          },
          {
            condition: { 'mdiCJC1295Ipamorelin_breastfeeding.yes': true },
            key: 'mdiCJC1295Ipamorelin_wereSorryTreatmentNotMedically'
          }
        ],
        els: 'mdiCJC1295Ipamorelin_importantClickAttachedLinkReview'
      }
    },
    'mdiCJC1295Ipamorelin_wereSorryTreatmentNotMedically',
    'mdiCJC1295Ipamorelin_importantClickAttachedLinkReview',
    'mdiCJC1295Ipamorelin_reasonInterestedPeptide',
    {
      key: 'mdiCJC1295Ipamorelin_everUsedPeptideTherapiesPast',
      next: {
        condition: {
          'mdiCJC1295Ipamorelin_everUsedPeptideTherapiesPast.yes': true
        },
        key: 'mdiCJC1295Ipamorelin_peptidesUsedPreviously',
        els: 'mdiCJC1295Ipamorelin_everReactionSideEffectsPeptide'
      }
    },
    'mdiCJC1295Ipamorelin_peptidesUsedPreviously',
    {
      key: 'mdiCJC1295Ipamorelin_everReactionSideEffectsPeptide',
      next: {
        condition: {
          'mdiCJC1295Ipamorelin_everReactionSideEffectsPeptide.yes': true
        },
        key: 'mdiCJC1295Ipamorelin_reactionSideEffect',
        els: 'mdiCJC1295Ipamorelin_diagnosedRedFlagMedicalConditions'
      }
    },
    'mdiCJC1295Ipamorelin_reactionSideEffect',
    'mdiCJC1295Ipamorelin_diagnosedRedFlagMedicalConditions',
    'mdiCJC1295Ipamorelin_confirmNotHistoryCancerKidney',
    'mdiCJC1295Ipamorelin_takeRedFlagMedicationsSubstances',
    'mdiCJC1295Ipamorelin_allergyBenzylPeroxide',
    'mdiCJC1295Ipamorelin_lastTimePersonMedicalEvaluation',
    'mdiCJC1295Ipamorelin_confirmUnderstandContactDoctorQuestions',
    'mdiCJC1295Ipamorelin_firstMessageDoctor',
    'mdiCJC1295Ipamorelin_complete'
  ]
};
